// utils/url.ts
export function toAbsoluteUrl(u?: string): string {
  const s = (u || "").trim();
  if (!s) return "";
  try { new URL(s); return s; } catch {}
  return "https://" + s.replace(/^\s*https?:\/\//i, "");
}
